import { BaseListenable1u3g4s45l82o6 as BaseListenable } from './abstracts.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  valueSet3cf2hvvu95f3 as valueSet,
  set1y8eiqnqugbz3 as set,
  getValue6qi464mhg2s5 as getValue,
  setValue39oxnnnmdq4h2 as setValue,
  lens2e2i845xidu26 as lens,
  lens26es9640ifscs as lens_0,
  get_state389x218zizu8a as get_state,
  MutableReactiveValuettf5l2qj6mxh as MutableReactiveValue,
} from './coreInterfaces.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ReactiveMutableSetClass;
function ReactiveMutableSet() {
  if (ReactiveMutableSetClass === VOID) {
    class $ extends BaseListenable() {
      static aao(hashSet) {
        var $this = this.uam();
        $this.zan_1 = hashSet;
        return $this;
      }
      static bao() {
        return this.aao(LinkedHashSet().v1());
      }
      cao(value) {
        if (!this.zan_1.equals(value)) {
          this.zan_1.v3();
          this.zam(value);
        }
      }
      oam(_set____db54di) {
        return this.cao((!(_set____db54di == null) ? isInterface(_set____db54di, KtSet()) : false) ? _set____db54di : THROW_CCE());
      }
      f2() {
        return this.zan_1;
      }
      v3() {
        if (this.i1())
          return Unit_instance;
        this.zan_1.v3();
        this.mal();
      }
      aan(elements) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableSet.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.zan_1.x3(toSet(elements));
        if (this_0) {
          this.mal();
        }
        return this_0;
      }
      x3(elements) {
        return this.aan(elements);
      }
      ban(elements) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableSet.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.zan_1.w2(toSet(elements));
        if (this_0) {
          this.mal();
        }
        return this_0;
      }
      w2(elements) {
        return this.ban(elements);
      }
      zam(elements) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableSet.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.zan_1.r1(elements);
        if (this_0) {
          this.mal();
        }
        return this_0;
      }
      r1(elements) {
        return this.zam(elements);
      }
      nam(element) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableSet.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.zan_1.v(element);
        if (this_0) {
          this.mal();
        }
        return this_0;
      }
      v(element) {
        return this.nam((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      mam(element) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveMutableSet.signal' call
        // Inline function 'kotlin.also' call
        var this_0 = this.zan_1.w3(element);
        if (this_0) {
          this.mal();
        }
        return this_0;
      }
      w3(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.mam((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      m1() {
        return this.zan_1.m1();
      }
      i1() {
        return this.zan_1.i1();
      }
      kl(element) {
        return this.zan_1.t1(element);
      }
      t1(element) {
        if (!(element == null ? true : !(element == null)))
          return false;
        return this.kl((element == null ? true : !(element == null)) ? element : THROW_CCE());
      }
      dan(elements) {
        return this.zan_1.l3(elements);
      }
      l3(elements) {
        return this.dan(elements);
      }
      p1() {
        return this.zan_1.p1();
      }
      qam(thisRef, property) {
        return this.pam((thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE(), property);
      }
      sam(thisRef, property, value) {
        var tmp = (thisRef == null ? true : !(thisRef == null)) ? thisRef : THROW_CCE();
        return this.ram(tmp, property, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
    }
    protoOf($).eak = valueSet;
    protoOf($).iah = set;
    protoOf($).pam = getValue;
    protoOf($).ram = setValue;
    protoOf($).vak = lens;
    protoOf($).dak = lens_0;
    protoOf($).sah = get_state;
    initMetadataForClass($, 'ReactiveMutableSet', $.bao, VOID, [KtMutableSet(), MutableReactiveValue(), BaseListenable()], [1]);
    ReactiveMutableSetClass = $;
  }
  return ReactiveMutableSetClass;
}
//region block: exports
export {
  ReactiveMutableSet as ReactiveMutableSet2bktc9g3zyrtk,
};
//endregion

//# sourceMappingURL=ReactiveMutableSet.mjs.map
